module.exports = __webpack_public_path__ + "media/svg-new/avatar-6 1-83df16ce.svg";